import api, { handleApiResponse } from './client';

export const getProducts = async () => {
  const result = await handleApiResponse(api.get('/products'));
  if (!result.success) {
    throw new Error(result.error || 'Failed to fetch products');
  }
  return result.data.data || [];
};

// Get all products (for when no category filter is selected)
export const getAllProducts = async () => {
  const result = await handleApiResponse(api.get('/products'));
  if (!result.success) {
    throw new Error(result.error || 'Failed to fetch all products');
  }
  return result.data.data || [];
};

// Get products for the shop page (no pagination)
export const getProductsForShop = async () => {
  const result = await handleApiResponse(api.get('/products/forshop'));
  if (!result.success) {
    throw new Error(result.error || 'Failed to fetch shop products');
  }
  return result.data.products || [];
};

// Get products by category
export const getProductsByCategory = async (categoryId) => {
  const result = await handleApiResponse(api.get(`/categories/${categoryId}/products`));
  if (!result.success) {
    throw new Error(result.error || 'Failed to fetch category products');
  }
  return result.data.data || [];
};

// Get category metadata + products in one call.
// The /categories/:slug/products endpoint already returns both — use them together.
export const getCategoryWithProducts = async (slug) => {
  const result = await handleApiResponse(api.get(`/categories/${slug}/products`));
  if (!result.success) {
    throw new Error(result.error || 'Failed to fetch category');
  }
  return {
    category: result.data.category || null,
    products: result.data.data || [],
  };
};

export const getProductById = async (id) => {
  const result = await handleApiResponse(api.get(`/products/${id}`));
  if (!result.success) {
    throw new Error(result.error || 'Failed to fetch product');
  }
  return result.data.data;
};

export const addReview = async (productId, data) => {
  const result = await handleApiResponse(api.post(`/products/${productId}/reviews`, data));
  if (!result.success) {
    throw new Error(result.error || 'Failed to add review');
  }
  return result.data;
};

export const getReviews = async (productId) => {
  const result = await handleApiResponse(api.get(`/products/${productId}/reviews`));
  if (!result.success) {
    throw new Error(result.error || 'Failed to fetch reviews');
  }
  return result.data.data || [];
};

export const searchProducts = async (query) => {
  const result = await handleApiResponse(api.get(`/products?search=${encodeURIComponent(query)}`));
  if (!result.success) {
    throw new Error(result.error || 'Failed to search products');
  }
  return result.data.data || [];
};

export const getSuggestions = async (query) => {
  const result = await handleApiResponse(api.get(`/suggestions?search=${encodeURIComponent(query)}`));
  if (!result.success) {
    throw new Error(result.error || 'Failed to fetch suggestions');
  }
  const payload = result.data?.data || {};
  return {
    products: payload.data || [],
    total: payload.total || 0,
    remaining: payload.remaining || 0,
  };
};

// Logs which search term led to a product click, for the admin dashboard's
// "Latest Searches" panel. Best-effort — a failure here should never block
// navigation to the product page.
export const trackSuggestionClick = (query) => {
  api.post('/suggestions/track', { term: query }).catch(() => {});
};